import { render, staticRenderFns } from "./showPingYiDialog1.vue?vue&type=template&id=08e45723&scoped=true&"
import script from "./showPingYiDialog1.vue?vue&type=script&lang=js&"
export * from "./showPingYiDialog1.vue?vue&type=script&lang=js&"
import style0 from "./showPingYiDialog1.vue?vue&type=style&index=0&id=08e45723&prod&lang=less&scoped=true&"
import style1 from "./showPingYiDialog1.vue?vue&type=style&index=1&id=08e45723&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e45723",
  null
  
)

export default component.exports